<template>
  <v-container fluid>
    <UnsavedChangesModal />
    <v-row>
      <v-col md="4" cols="3">
        <h1>{{ $t("story.coverArt.coverArt") }}</h1>
        <StoryImageCard />
      </v-col>
      <v-col md="8" cols=8 class="mb-6">
        <h1>
          {{ $t("story.basicInfoForm.info") }}
          <v-btn
            rounded
            class="save-button px-10"
            color="primary"
            elevation="0"
            small
            @click="submitStory()"
            :loading="getInProgress"
            :disabled="getInProgress || !hasChanges"
          >
            {{ $t("forms.save") }}
          </v-btn>
        </h1>
        <BasicInfoForm @unauthorized="unauthorized" ref="basicInfoForm" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StoryImageCard from "@/components/CreatorTools/StoryHub/BasicInfo/StoryImageCard";
import BasicInfoForm from "@/components/CreatorTools/StoryHub/BasicInfo/BasicInfoForm";
import UnsavedChangesModal from "@/components/UnsavedChangesModal";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      this.showUnsavedChangesModal(next);
    } else {
      next();
    }
  },
  name: "BasicInfoTab",
  components: {
    StoryImageCard,
    BasicInfoForm,
    UnsavedChangesModal,
  },
  computed: {
    ...mapGetters("story", ["getInProgress", "getStory", "getEditedStory"]),
    hasChanges: function () {
      return (
        JSON.stringify(this.getStory) !== JSON.stringify(this.getEditedStory)
      );
    },
  },
  methods: {
    unauthorized() {
      this.$emit("unauthorized");
    },
    ...mapMutations("story", [
      "setStory",
      "setStory",
      "setEditedStory",
      "setShowUnsavedChangesModal",
    ]),
    ...mapActions("formNavGuard", ["showUnsavedChangesModal"]),
    submitStory() {
      this.$refs.basicInfoForm.validate();
      this.$refs.basicInfoForm.saveStory();
    },
  },
};
</script>
<style scoped>
.save-button {
  float: right;
}
</style>